import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingOutlined } from '@ant-design/icons';
import './CGButton.scss';
export const CGButton = ({ type = 'default', size = 'middle', shape = 'normal', variant = 'filled', color, icon, loading = false, disabled = false, danger = false, ghost = false, block = false, htmlType = 'button', className = '', children, onClick, style, ...props }) => {
    const handleClick = (event) => {
        if (loading || disabled)
            return;
        onClick?.(event);
    };
    // ✅ Build button classes including variant
    const buttonClasses = [
        'cg-btn',
        `cg-btn-${type}`,
        `cg-btn-${size}`,
        `cg-btn-${shape}`,
        `cg-btn-variant-${variant}`,
        danger && 'cg-btn-danger',
        ghost && 'cg-btn-ghost',
        block && 'cg-btn-block',
        loading && 'cg-btn-loading',
        disabled && 'cg-btn-disabled',
        color && 'cg-btn-custom-color',
        className
    ]
        .filter(Boolean)
        .join(' ');
    // ✅ Generate dynamic styles based on color and variant
    const getCustomStyles = () => {
        if (!color)
            return style || {};
        const baseStyle = { ...style };
        switch (variant) {
            case 'filled':
                return {
                    ...baseStyle,
                    backgroundColor: color,
                    borderColor: color,
                    color: '#ffffff',
                    '--hover-bg': `${color}dd`,
                    '--active-bg': `${color}bb`
                };
            case 'outlined':
                return {
                    ...baseStyle,
                    backgroundColor: 'transparent',
                    borderColor: color,
                    color: color,
                    '--hover-bg': `${color}10`,
                    '--active-bg': `${color}20`
                };
            case 'text':
                return {
                    ...baseStyle,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: color,
                    '--hover-bg': `${color}10`,
                    '--active-bg': `${color}20`
                };
            case 'link':
                return {
                    ...baseStyle,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: color,
                    textDecoration: 'none',
                    '--hover-color': `${color}dd`,
                    '--active-color': `${color}bb`
                };
            default:
                return baseStyle;
        }
    };
    const iconElement = loading ? _jsx(LoadingOutlined, {}) : icon;
    return (_jsxs("button", { type: htmlType, className: buttonClasses, onClick: handleClick, disabled: disabled || loading, style: getCustomStyles(), ...props, children: [iconElement && _jsx("span", { className: `cg-btn-icon ${children ? 'with-text' : 'icon-only'}`, children: iconElement }), children && _jsx("span", { className: 'cg-btn-text', children: children })] }));
};
export default CGButton;
